import { zLogRocket } from '@zoll/logrocket-vue2-lib';

export const plugins = [zLogRocket.utilities.vuexPlugin];
